export enum SortOrder {
    Asc = "Asc",
    Desc = "Desc"
}

export enum SortDirection {
    Asc = 0,
    Desc = 1
}
